export const HasOrganizationPaymentMethodBeenAdded = (requirePaymentMethodToInviteAthletes, organizationAdminStripeCustomerId) => {

    if (requirePaymentMethodToInviteAthletes === 0) { 
        return true
    }

    if (requirePaymentMethodToInviteAthletes === 1) {

        if (organizationAdminStripeCustomerId === '') {
            return false
        }

        return true
    }

}